module.exports = __webpack_public_path__ + "a4e472da984583f0a5dc2128cf572a04.png";